<app-heatmap *ngIf="heatmapService.isEnabled | async"></app-heatmap>
<router-outlet></router-outlet>
